module.exports = __webpack_public_path__ + "img/tencent.4708fd9a.jpg";